import { render, staticRenderFns } from "./RemoveTenantClient.vue?vue&type=template&id=6ee954bc&scoped=true"
import script from "./RemoveTenantClient.vue?vue&type=script&lang=js"
export * from "./RemoveTenantClient.vue?vue&type=script&lang=js"
import style0 from "./RemoveTenantClient.vue?vue&type=style&index=0&id=6ee954bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee954bc",
  null
  
)

export default component.exports